import {ISyncField, TFieldType} from "../../index";
import {ITableColumnDefinition} from "./index";
import {getPermissionDefinition} from "../../util/misc";

export namespace nsSystemfields {
    export const TableColumnDefinitions: Partial<Record<keyof ISyncField, ITableColumnDefinition>> = {
        core: {
            content: obj => obj.syncfield.core.toString(),
            key: 'core',
            title: '',
            tt: 'core value',
            type: 'boolean',
        },
        description: {
            content: obj => obj.syncfield.description,
            key: 'description',
            title: 'description',
            tt: '((translation)): ((description))',
            type: 'string',
        },
        displayname: {
            content: obj => obj.syncfield.displayname,
            key: 'displayname',
            title: 'displayname',
            tt: '((translation)): ((displayname))',
            type: 'string',
        },
        fieldtype: {
            cellCss: 'cell__nowrap',
            content: obj => obj.syncfield.fieldtype,
            key: 'fieldtype',
            tt: '((translation)): ((fieldtype))',
            type: 'fieldtype',
        },
        ignorefilter: {
            content: obj => obj.syncfield.ignorefilter.toString(),
            key: 'ignorefilter',
            tt: '((synchronization field)): ((ignorefilter))',
            type: 'boolean',
        },
        isoverridablebylevel: {
            content: obj => getPermissionDefinition(obj.syncfield.isoverridablebylevel)?.displayName,
            key: 'isoverridablebylevel',
            title: 'overridable by',
            tt: '((synchronization field)): ((overridable by))',
            type: 'permission',
        },
        issynced: {
            content: obj => obj.syncfield.issynced.toString(),
            key: 'issynced',
            tt: '((synchronization field)): ((issynced))',
            type: 'boolean',
        },
        maxlength: {
            cellCss: 'cell__id',
            content: obj => obj.syncfield.maxlength.toString(),
            key: 'maxlength',
            title: '((max)) ((length|ac))',
            tt: '((max)) ((length|ac))',
            type: 'number',
        },
        name: {
            content: obj => obj.syncfield.name,
            key: 'name',
            title: 'name',
            tt: '((synchronization field)): ((name))',
            type: 'string',
        },
        parameters: {
            content: obj => obj.syncfield.parameters,
            key: 'parameters',
            title: 'parameter|p',
            tt: '((translation)): ((parameter|p))',
            type: 'string',
        },
        referencefieldid: {
            cellCss: 'cell__id',
            content: obj => obj.syncfield.referencefieldid,
            key: 'referencefieldid',
            tt: '((translation)): ((referencefieldid))',
            type: 'syncfieldid',
        },
        referenceobjecttypeid: {
            cellCss: 'cell__id',
            content: obj => obj.syncfield.referenceobjecttypeid,
            key: 'referenceobjecttypeid',
            tt: '((translation)): ((referenceobjecttypeid))',
            type: 'objecttypeid',
        },
        required: {
            content: obj => obj.syncfield.required.toString(),
            key: 'required',
            tt: '((synchronization field)): ((required))',
            type: 'boolean',
        },
        syncfielddisplaynameid: {
            cellCss: 'cell__id',
            content: obj => obj.syncfield.syncfielddisplaynameid,
            key: 'syncfielddisplaynameid',
            title: 'id',
            tt: '((translation)): ((id))',
            type: 'number',
        },
        syncfieldid: {
            cellCss: 'cell__id',
            content: obj => obj.syncfield.syncfieldid,
            key: 'syncfieldid',
            title: 'id',
            tt: '((synchronization field)): ((id))',
            type: 'number',
        },
    }

    export function getDef(key: keyof ISyncField): ITableColumnDefinition {
        return TableColumnDefinitions[key]!
    }

    export const AvailableFieldTypes: TFieldType[] = ['Array', 'DateTime', 'Function', 'Int', 'Reference', 'String'];

    export const isMutable: boolean = window.location.hostname.endsWith('.no')

}